// Canada Post never uses D, F, I, O, Q or U, and W and Z never lead.
const CA_POSTAL = '[ABCEGHJ-NPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z] ?\\d[ABCEGHJ-NPRSTV-Z]\\d';

/** PORTAL-2413: the ZIP / postal code inputs' maxlength. Room for a ZIP+4 ("02138-1234") or a Canadian code typed with a space before and after (" M1J 2E5 "); findPostalCode then picks the code out. */
export const POSTAL_CODE_INPUT_MAX_LENGTH = 10;

/** A US ZIP ("02141", with a ZIP+4 cut to its five digits) or a Canadian code ("M5V 3L9") in canonical form; null otherwise. */
export function normalizePostalCode(value: string | null | undefined): string | null {
  const code = (value || '').trim().toUpperCase();
  if (/^\d{5}(-\d{4})?$/.test(code)) return code.slice(0, 5);
  const compact = code.replace(/\s/g, '');
  return new RegExp(`^${CA_POSTAL}$`, 'i').test(compact) ? `${compact.slice(0, 3)} ${compact.slice(3)}` : null;
}

/** The first US ZIP or Canadian postal code inside free text, canonical; null when there is none. */
export function findPostalCode(text: string | null | undefined): string | null {
  const match = (text || '').match(new RegExp(`\\b(\\d{5})\\b|\\b(${CA_POSTAL})\\b`, 'i'));
  return match ? normalizePostalCode(match[1] || match[2]) : null;
}

/** The postal code of a Google geocoder result. */
export function postalCodeFromGeocoderResult(result: google.maps.GeocoderResult | undefined): string | null {
  if (!result) return null;
  const component = result.address_components?.find((c) => c.types.includes('postal_code'));
  return normalizePostalCode(component?.long_name) ?? findPostalCode(result.formatted_address);
}

/** 'US' or 'CA' for a valid ZIP or postal code; null otherwise. */
export function countryOfPostalCode(value: string | null | undefined): 'US' | 'CA' | null {
  const code = normalizePostalCode(value);
  if (!code) return null;
  return /^\d/.test(code) ? 'US' : 'CA';
}
